import React, {Component} from "react";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import {Redirect, Route, Switch, withRouter} from "react-router-dom";
import {getCurrentUser, request} from "../util/APIUtils";
import {ACCESS_TOKEN, API_BASE_URL} from "../constants";
import Login from "../page/login/Login";
import NotFound from "../common/NotFound";
import Alert from "react-s-alert";
import "react-s-alert/dist/s-alert-default.css";
import "react-s-alert/dist/s-alert-css-effects/slide.css";
import "react-s-alert/dist/s-alert-css-effects/scale.css";
import "react-s-alert/dist/s-alert-css-effects/genie.css";
import "react-s-alert/dist/s-alert-css-effects/jelly.css";
import "react-s-alert/dist/s-alert-css-effects/stackslide.css";
import Home from "../page/home/Home";
import Profile from "../page/profile/Profile";
import Member from "../page/member/Member";
import Oda from "../page/odaList/OdaList";
import MemberList from "../page/memberList/MemberList";
import RegistrationOk from "../page/signup/RegistrationOk";
import RegistrationNotOk from "../page/signup/RegistrationNotOk";
import ResetPassword from "../page/signup/ResetPassword";
import ChangePassword from "../page/signup/ChangePassword";
import MemberGeneralInfo from "../page/memberList/MemberGeneralInfo";
import MemberContactInfo from "../page/memberList/MemberContactInfo";
import AnnouncementList from "../page/announcement/AnnouncementList";
import AnnouncementItem from "../page/announcement/AnnouncementItem";
import AnnouncementMainPage from "../page/announcement/AnnouncementMainPage";
import OperatingCertificate from "../page/operatingCertificate/OperatingCertificate";
import MemberTransferList from "../page/memberTransferList/MemberTransferList";
import UserList from "../page/user/UserList";
import ChangePasswordInner from "../page/signup/ChangePasswordInner";
import PaymentList from "../page/financial/PaymentList";
import IncomeList from "../page/financial/IncomeList";
import Balance from "../page/financial/Balance";
import AccrualList from "../page/financial/AccrualList";
import FinancialParameters from "../page/financial/FinancialParameters";
import ReceiptList from "../page/financial/ReceiptList";
import CertificatePage from "../page/home/CertificatePage";
import {Modal} from "antd";
import IdleTimer from "react-idle-timer";
import ChangeRequestList from "../page/changeRequest/ChangeRequestList";
import MailLogs from "../page/mailLogs/MailLogs";
import DocumentDownloadPage from "../page/home/DocumentDownloadPage";
import {showAxiosError} from "../util/Helpers";
import CertificateVerification from "../page/home/CertificateVerification";
import AccrualStats from "../page/financial/AccrualStats";
import CityTransfer from "../page/cityTransfer/CityTransfer";
import UserGuide from "../page/userGuide/UserGuide";
import PassiveMemberListWithDebit from "../page/memberList/PassiveMemberListWithDebit";
import OnDutyList from "../page/onduty/OnDutyList";
import NobetParams from "../page/nobetParams/NobetParams";
import MeetingList from "../page/odaList/MeetingList";
import DocumentList from "../page/documentList/DocumentList";
import NobetTalep from "../page/nobetParams/NobetTalep";
import SurveyQuestionsPage from "../page/surveypage/SurveyQuestionsPage";
import BoardManagementCalender from "../page/agenda/boardManagementCalendar";
import CommissionCalendar from "../page/agenda/commissionCalendar";
import IndividualCalendars from "../page/agenda/individualCalendars";
import AccrualListUye from "../page/financial/AccrualListUye";
import MemberCreate from "../page/memberList/MemberCreate";
import WpUserList from "../page/wpuser/WpUserList";
import PharmacyList from "../page/pharmacyList/PharmacyList";
import Region from "../page/regions/Region";
import NewSurveyListPage from "../page/surveypage/NewSurveyListPage";
import NewMySurveys from "../page/surveypage/NewMySurveys";
import DetailModal from "../page/jobPosting/DetailModal";
import JobPostingList from "../page/jobPosting/JobPostingList";
import Youtube from "../page/youtube/Youtube";
import Signup from "../page/signup/Signup";
import NewMemberCreate from "../page/memberList/NewMemberCreate";
import UnderConstruction from "../common/UnderConstruction";
import DutyRoster from "../page/dutyRoster/dutyRoster";
import ActivationHandler from "../page/signup/ActivationHandler";
import DealList from "../page/deal/DealList";

class Master extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: null,
      authorities: [],
      isAuthenticated: false,
      isLoading: false,
      key: Math.random(),
      offsetWidth: null,
      cities: [],
      branches: [],
      allBranches: [],
      countBackFrom: 30,
      countingBack: false,
      maxIdleTimeout: 15,
      showDownloadRequestTooltip: false,
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.loadCurrentUser = this.loadCurrentUser.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.setOffsetWidth = this.setOffsetWidth.bind(this);
    this.updateSidebarMenus = this.updateSidebarMenus.bind(this);
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.showModal = this.showModal.bind(this);
    this.timer = this.timer.bind(this);
    this.countback = this.countback.bind(this);
    this.triggerDownloadRequestTooltip =
      this.triggerDownloadRequestTooltip.bind(this);
    this.listBranches = this.listBranches.bind(this);
    this.listCities = this.listCities.bind(this);
    this.rightExists = this.rightExists.bind(this);
    this.listBranchesAll = this.listBranchesAll.bind(this);
  }

  componentWillMount() {
    this.loadCurrentUser();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  updateSidebarMenus(menuList) {
    let { currentUser } = this.state;
    currentUser.sidebarMenus = menuList;
    this.setState({ currentUser });
  }

  loadCurrentUser() {
    const curLocation = this.props.location.pathname;
    this.setState({ isLoading: true });
    getCurrentUser()
      .then((response) => {
        let currentUser = response.data;
        this.setState(
          {
            currentUser: currentUser,
            authorities: currentUser.authorities,
            isAuthenticated: true,
            isLoading: false,
          },
          () => {
            this.props.history.push(
              curLocation !== "/login" ? curLocation : "/homePage"
            );
            this.listBranchesAll();
            if (currentUser.realm != null) {
              this.listCities();
              this.listBranches();
            }
          }
        );
      })
      .catch(() => {
        if (
            curLocation === "/activation" ||
          curLocation === "/registrationOk" ||
          curLocation === "/registrationNotOk" ||
          curLocation === "/resetPassword" ||
          curLocation === "/belge_dogrulama" ||
          curLocation.toString().startsWith("/changePassword")
        ) {
          this.setState({
            isLoading: false,
            currentUser: null,
            isAuthenticated: false,
          });
        } else {
          this.setState(
            {
              isLoading: false,
              currentUser: null,
              isAuthenticated: false,
            },
            () => {
              this.props.history.push("/login");
            }
          );
        }
      });
  }

  handleLogout(redirectTo = "/login") {
    localStorage.removeItem(ACCESS_TOKEN);
    this.setState(
      {
        currentUser: null,
        isAuthenticated: false,
        visible: false,
        countingBack: false,
        countBackFrom: 30,
      },
      () => this.props.history.push(redirectTo)
    );
  }

  handleLogin() {
    this.loadCurrentUser();
  }

  handleCancel() {
    let self = this;
    self.setState({ visible: false, countingBack: false, countBackFrom: 30 });
  }

  setOffsetWidth(value) {
    this.setState({ offsetWidth: value });
  }

  _onAction(e) {}

  _onActive(e) {}

  _onIdle() {
    let self = this;
    self.showModal();
  }

  async showModal() {
    let self = this;
    self.setState(
      {
        visible: true,
        countingBack: true,
      },
      () => self.countback()
    );
  }

  async countback() {
    let self = this;
    while (self.state.countBackFrom > 0 && self.state.countingBack) {
      await self.timer(1000);
      self.setState({ countBackFrom: self.state.countBackFrom - 1 });
    }
    if (self.state.countBackFrom === 0) {
      self.setState(
        { visible: false, countBackFrom: 30, countingBack: false },
        () => this.handleLogout()
      );
    }
  }

  timer(ms) {
    return new Promise((res) => setTimeout(res, ms));
  }

  listCities() {
    let self = this;
    let params = {
      url: API_BASE_URL + "/city",
      method: "get",
    };
    request(params)
      .then(function (response) {
        let cities = response.data;
        let cityMap = cities.map((item) => ({
          label: item.ad,
          value: item.id.toString(),
            oda:{
              id: item.oda && item.oda.id,
            },
            citySubDivisions:item.citySubDivisions,
        }));
        self.setState({
          cities: cityMap,
        });
      })
      .catch(function (error) {
        showAxiosError(error);
      });
  }

  listBranches() {
    let self = this;
    let params = {
      url: API_BASE_URL + "/oda/oda-list/",
      method: "get",
    };
    request(params)
      .then(function (response) {
        let branches = response.data;
        self.setState({
          branches,
        });
      })
      .catch(function (error) {
        showAxiosError(error);
      });
  }

  listBranchesAll() {
    let self = this;
    let params = {
      url: API_BASE_URL + "/oda/oda-list-all/",
      method: "get",
    };
    request(params)
      .then(function (response) {
        let allBranches = response.data;
        self.setState({
          allBranches,
        });
      })
      .catch(function (error) {
        showAxiosError(error);
      });
  }

  async triggerDownloadRequestTooltip() {
    this.setState({
      showDownloadRequestTooltip: true,
    });
    await this.sleep(8000);
    this.setState({
      showDownloadRequestTooltip: false,
    });
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  rightExists(searchItem) {
    let exists = false;
    const authorities = this.state.authorities;
    for (const authority of authorities) {
      if (authority.authority.includes(searchItem)) {
        exists = true;
      }
    }
    return exists;
  }

  render() {
    let siteContent = this.siteContent();
    if (this.state.isLoading) {
      return (
        <div className="loading-container">
          <div className="bouncing-loader">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        // <div>Sayfa yükleniyor</div>;
      );
    }
    return (
      <div>
        {this.state.isAuthenticated ? (
          siteContent
        ) : (
          <Switch>
            <Route
              exact
              path="/login"
              render={(props) => (
                <Login onLogin={this.handleLogin} {...props} />
              )}
            />
            <Route
              path="/registrationOk"
              render={(props) => <RegistrationOk {...props} />}
            />
            <Route
              path="/registrationNotOk"
              render={(props) => <RegistrationNotOk {...props} />}
            />
              <Route
                  path="/resetPassword"
                  render={(props) => <ResetPassword {...props} />}
              />
              <Route
                  path="/activation"
                  render={(props) => <ActivationHandler {...props} />}
              />
            <Route
              path="/belge_dogrulama"
              render={(props) => <CertificateVerification {...props} />}
            />
            <Route
              path="/changePassword/:resetKey"
              render={(props) => <ChangePassword {...props} />}
            />
                  <Route
              exact
              path="/signup"
              render={(props) => (
                <Signup onLogin={this.handleLogin} {...props} />
              )}
            />
         
            {/*<Route path="/signup"*/}
            {/*	   render={(props) => <Signup onLogin={this.handleLogin} {...props} />}/>*/}
            <Redirect path="/" to="/login" />
            <Route component={NotFound} />
          </Switch>
        )}
        <Alert stack={{ limit: 3 }} html={true} offset={45} />
      </div>
    );
  }

  siteContent() {
    return (
      <div>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={1000 * 60 * this.state.maxIdleTimeout}
        />
        <div className="wrapper">
          <Sidebar
            isAuthenticated={this.state.isAuthenticated}
            currentUser={this.state.currentUser}
            authorities={this.state.authorities}
            history={this.props.history}
            setOffsetWidth={this.setOffsetWidth}
            onLogout={this.handleLogout}
            showDownloadRequestTooltip={this.state.showDownloadRequestTooltip}

          />
          <div className="main-panel">
            {/* <Header
              isAuthenticated={this.state.isAuthenticated}
              currentUser={this.state.currentUser}
              location={this.props.location.pathname}
              onLogout={this.handleLogout}
              offsetWidth={this.state.offsetWidth}
              showDownloadRequestTooltip={this.state.showDownloadRequestTooltip}
            /> */}
                        <div className="content main-container" key={this.state.key} style={{marginTop: "-90px"}}>
                            <Switch currentUser={this.state.currentUser}>
                                <Route
                                    exact
                                    path="/underconstruction"
                                    render={(props) => (
                                        <UnderConstruction/>
                                    )}
                                />
                                <Route
                                    exact
                                    path="/"
                                    render={(props) => (
                                        <Home
                                            isAuthenticated={this.state.isAuthenticated}
                                            currentUser={this.state.currentUser}
                                            authorities={this.state.authorities}
                                            {...props}
                                        />
                                    )}
                                />
                                {this.rightExists("ROLE_RIGHT_MEMBER_READ") && (
                                    <Route
                                        path="/member"
                                        render={(props) => (
                                            <Member {...props} handleLogout={this.handleLogout}/>
                                        )}
                                    />
                                )}
                                {this.rightExists("ROLE_RIGHT_BRANCH_READ") && (
                                    <Route
                                        path="/odaList"
                                        render={(props) => (
                                            <Oda
                                                {...props}
                                                currentUser={this.state.currentUser}
                                                authorities={this.state.authorities}
                                                handleLogout={this.handleLogout}
                                            />
                                        )}
                                    />
                                )}
                                {this.rightExists("ROLE_RIGHT_FINANCIAL_PARAMETERS_CREATE") && (
                                    <Route
                                        path="/cityTransfer"
                                        render={(props) => (
                                            <CityTransfer
                                                currentUser={this.state.currentUser}
                                                {...props}
                                                allBranches={this.state.allBranches}
                                                authorities={this.state.authorities}
                                                handleLogout={this.handleLogout}
                                            />
                                        )}
                                    />
                                )}
                                {this.rightExists("ROLE_RIGHT_MEMBER_READ") && (
                                    <Route
                                        path="/MemberListReview"
                                        render={(props) => (
                                            <MemberList
                                                {...props}
                                                key="review"
                                                currentUser={this.state.currentUser}
                                                handleLogout={this.handleLogout}
                                                authorities={this.state.authorities}

                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_MEMBER_READ") && (
                  <Route
                    path="/MemberListApproval"
                    render={(props) => (
                      <MemberList
                        {...props}
                        key="approval"
                        currentUser={this.state.currentUser}
                        handleLogout={this.handleLogout}
                        authorities={this.state.authorities}
                        triggerDownloadRequestTooltip={
                          this.triggerDownloadRequestTooltip
                        }
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_MEMBER_READ") && (
                  <Route
                    path="/PassiveMemberListWithDebit"
                    render={(props) => (
                      <PassiveMemberListWithDebit
                        {...props}
                        key="approval"
                        currentUser={this.state.currentUser}
                        handleLogout={this.handleLogout}
                        triggerDownloadRequestTooltip={
                          this.triggerDownloadRequestTooltip
                        }
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_MEMBER_READ") && (
                  <Route
                    path="/mailLogs"
                    render={(props) => (
                      <MailLogs
                        {...props}
                        currentUser={this.state.currentUser}
                        handleLogout={this.handleLogout}
                      />
                    )}
                  />
                )}

                <Route
                  path="/homePage"
                  render={(props) => (
                    <Home
                      isAuthenticated={this.state.isAuthenticated}
                      currentUser={this.state.currentUser}
                      authorities={this.state.authorities}
                      handleLogout={this.handleLogout}
                      {...props}
                    />
                  )}
                />

                {this.rightExists("ROLE_RIGHT_MEMBER_READ") && (
                  <Route
                    path="/user"
                    render={(props) => (
                      <Profile
                        isAuthenticated={this.state.isAuthenticated}
                        currentUser={this.state.currentUser}
                        {...props}
                        handleLogout={this.handleLogout}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_SELF_READ") && (
                  <Route
                    path="/changePasswordInner"
                    render={(props) => (
                      <ChangePasswordInner
                        isAuthenticated={this.state.isAuthenticated}
                        currentUser={this.state.currentUser}
                        handleLogout={this.handleLogout}
                        {...props}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_SELF_READ") && (
                  <Route
                    path="/memberInfo"
                    render={(props) => (
                      <MemberGeneralInfo
                        {...props}
                        selectedMember={this.state.currentUser.member}
                        currentUser={this.state.currentUser}
                        handleLogout={this.handleLogout}
                        mode="edit"
                      />
                    )}
                  />
                )}

                {this.rightExists("ROLE_RIGHT_SELF_READ") && (
                  <Route
                    path="/memberContactInfo"
                    render={(props) => (
                      <MemberContactInfo
                        {...props}
                        selectedMember={this.state.currentUser.member}
                        handleLogout={this.handleLogout}
                        mode="review"
                      />
                    )}
                  />
                )}

                {this.rightExists("ROLE_RIGHT_ANNOUNCEMENT_CREATE") && (
                  <Route
                    path="/announcementList"
                    render={(props) => (
                      <AnnouncementList
                        {...props}
                        handleLogout={this.handleLogout}
                      />
                    )}
                  />
                )}
                <Route
                  path="/announcementItem"
                  render={(props) => (
                    <AnnouncementItem
                      {...props}
                      handleLogout={this.handleLogout}
                    />
                  )}
                />
                <Route
                  path="/announcementMainPage"
                  render={(props) => (
                    <AnnouncementMainPage
                      currentUser={this.state.currentUser}
                      handleLogout={this.handleLogout}
                      {...props}
                    />
                  )}
                />
                {this.rightExists("ROLE_RIGHT_BRANCH_READ") && (
                  <Route
                    path="/opCertificate"
                    render={(props) => (
                      <OperatingCertificate
                        currentUser={this.state.currentUser}
                        handleLogout={this.handleLogout}
                        {...props}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_DOCUMENT_WORK") && (
                  <Route
                    path="/documentList"
                    render={(props) => (
                      <DocumentList
                        {...props}
                        currentUser={this.state.currentUser}
                        handleLogout={this.handleLogout}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_MEMBER_READ") && (
                  <Route
                    path="/MemberListTransfer"
                    render={(props) => (
                      <MemberTransferList
                        {...props}
                        key="transfer"
                        currentUser={this.state.currentUser}
                        handleLogout={this.handleLogout}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_MEMBER_READ") && (
                  <Route
                    path="/userList"
                    render={(props) => (
                      <UserList
                        currentUser={this.state.currentUser}
                        {...props}
                        handleLogout={this.handleLogout}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_MEMBER_READ") && (
                  <Route
                    path="/userGuide"
                    render={(props) => (
                      <UserGuide
                        currentUser={this.state.currentUser}
                        {...props}
                        handleLogout={this.handleLogout}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_PAYMENT_READ") && (
                  <Route
                    path="/paymentList"
                    render={(props) => (
                      <PaymentList
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        handleLogout={this.handleLogout}
                        triggerDownloadRequestTooltip={
                          this.triggerDownloadRequestTooltip
                        }
                        cities={this.state.cities}
                        branches={this.state.branches}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_PAYMENT_READ") && (
                  <Route
                    path="/incomeList"
                    render={(props) => (
                      <IncomeList
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        handleLogout={this.handleLogout}
                        triggerDownloadRequestTooltip={
                          this.triggerDownloadRequestTooltip
                        }
                        cities={this.state.cities}
                        branches={this.state.branches}
                        allBranches={this.state.allBranches}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_PAYMENT_READ") && (
                  <Route
                    path="/balance"
                    render={(props) => (
                      <Balance
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        handleLogout={this.handleLogout}
                        cities={this.state.cities}
                        branches={this.state.branches}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_PAYMENT_READ") && (
                  <Route
                    path="/accrualList"
                    render={(props) => (
                      <AccrualList
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        handleLogout={this.handleLogout}
                        triggerDownloadRequestTooltip={
                          this.triggerDownloadRequestTooltip
                        }
                        cities={this.state.cities}
                        branches={this.state.branches}
                        allBranches={this.state.allBranches}
                      />
                    )}
                  />
                )}

                {!this.rightExists("ROLE_RIGHT_PAYMENT_READ") && (
                  <Route
                    path="/accrualListUye"
                    render={(props) => (
                      <AccrualListUye
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        handleLogout={this.handleLogout}
                        triggerDownloadRequestTooltip={
                          this.triggerDownloadRequestTooltip
                        }
                        cities={this.state.cities}
                        branches={this.state.branches}
                        allBranches={this.state.allBranches}
                      />
                    )}
                  />
                )}
                {this.rightExists("ROLE_RIGHT_FINANCIAL_PARAMETERS_CREATE") && (
                  <Route
                    path="/financialParameters"
                    render={(props) => (
                      <FinancialParameters
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        handleLogout={this.handleLogout}
                        triggerDownloadRequestTooltip={
                          this.triggerDownloadRequestTooltip
                        }
                      />
                    )}
                  />
                )}

                {this.rightExists("ROLE_RIGHT_PAYMENT_READ") && (
                  <Route
                    path="/receiptList"
                    render={(props) => (
                      <ReceiptList
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        handleLogout={this.handleLogout}
                        cities={this.state.cities}
                        branches={this.state.branches}
                      />
                    )}
                  />
                )}

                {this.rightExists("ROLE_RIGHT_SELF_READ") && (
                  <Route
                    path="/memberCertificatePage"
                    render={(props) => (
                      <CertificatePage
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        handleLogout={this.handleLogout}
                      />
                    )}
                  />
                )}

                <Route
                  path="/belge_dogrulama"
                  render={(props) => (
                    <CertificateVerification
                      currentUser={this.state.currentUser}
                      {...props}
                      authorities={this.state.authorities}
                      handleLogout={this.handleLogout}
                    />
                  )}
                />

                {this.rightExists("ROLE_RIGHT_MEMBER_READ") && (
                  <Route
                    path="/changeRequestList"
                    render={(props) => (
                      <ChangeRequestList
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        handleLogout={this.handleLogout}
                      />
                    )}
                  />
                )}

                {this.rightExists("ROLE_RIGHT_CHAMBER_DOCS_READ") && (
                  <Route
                    path="/docDownload"
                    render={(props) => (
                      <DocumentDownloadPage
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        handleLogout={this.handleLogout}
                      />
                    )}
                  />
                )}

                {
                  <Route
                    path="/accrualStats"
                    render={(props) => (
                      <AccrualStats
                        currentUser={this.state.currentUser}
                        {...props}
                        authorities={this.state.authorities}
                        cities={this.state.cities}
                        branches={this.state.branches}
                      />
                    )}
                  />
                }

                                {this.rightExists("ROLE_RIGHT_DUTY_READ") && (
                                    <Route
                                        path="/nobetcieczane"
                                        render={(props) => (
                                            <OnDutyList
                                                currentUser={this.state.currentUser}
                                                {...props}
                                                authorities={this.state.authorities}
                                                handleLogout={this.handleLogout}
                                                triggerDownloadRequestTooltip={
                                                    this.triggerDownloadRequestTooltip
                                                }
                                            />
                                        )}
                                    />
                                )}
                                {this.rightExists("ROLE_RIGHT_DUTY_READ") && (
                                    <Route
                                        path="/dutyRoster"
                                        render={(props) => (
                                            <DutyRoster
                                                currentUser={this.state.currentUser}
                                                {...props}
                                                authorities={this.state.authorities}
                                                handleLogout={this.handleLogout}
                                                triggerDownloadRequestTooltip={
                                                    this.triggerDownloadRequestTooltip
                                                }
                                            />
                                        )}
                                    />
                                )}
                                <Route
                                    path="/youtubeVideos"
                                    render={(props) => (
                                        <Youtube
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            triggerDownloadRequestTooltip={
                                                this.triggerDownloadRequestTooltip
                                            }
                                        />
                                    )}
                                />
                                <Route
                                    path="/anketlerim"
                                    render={(props) => (
                                        <NewMySurveys
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            triggerDownloadRequestTooltip={
                                                this.triggerDownloadRequestTooltip
                                            }
                                        />
                                    )}
                                />

                                <Route
                                    path="/anketler"
                                    render={(props) => (
                                        <NewSurveyListPage
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            triggerDownloadRequestTooltip={
                                                this.triggerDownloadRequestTooltip
                                            }
                                        />
                                    )}
                                />

                                <Route
                                    path="/anket/:id"
                                    render={(props) => (
                                        <SurveyQuestionsPage
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            triggerDownloadRequestTooltip={
                                                this.triggerDownloadRequestTooltip
                                            }
                                        />
                                    )}
                                />


                                <Route
                                    path="/uyeolustur"
                                    render={(props) => (
                                        <MemberCreate
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            triggerDownloadRequestTooltip={
                                                this.triggerDownloadRequestTooltip
                                            }
                                        />
                                    )}
                                />
                                <Route
                                    path="/newMember"
                                    render={(props) => (
                                        <NewMemberCreate
                                            currentUser={this.state.currentUser}
                                            selectedMember={this.state.currentUser.member}
                                            {...props}
                                            key="review"
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            triggerDownloadRequestTooltip={
                                                this.triggerDownloadRequestTooltip
                                            }
                                        />
                                    )}
                                />

                                <Redirect exact path="/login" to="/"/>

                                <Route
                                    path="/commissionMeeting"
                                    render={(props) => (
                                        <MeetingList
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            cities={this.state.cities}
                                            branches={this.state.branches}
                                        />
                                    )}
                                />

                                <Route
                                    path="/komisyontakvimi"
                                    render={(props) => (
                                        <CommissionCalendar
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            cities={this.state.cities}
                                            branches={this.state.branches}
                                        />
                                    )}
                                />

                                <Route
                                    path="/yonetimKuruluTakvimi"
                                    render={(props) => (
                                        <BoardManagementCalender
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            cities={this.state.cities}
                                            branches={this.state.branches}
                                        />
                                    )}
                                />

                                <Route
                                    path="/bireyselTakvimler"
                                    render={(props) => (
                                        <IndividualCalendars
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            cities={this.state.cities}
                                            branches={this.state.branches}
                                        />
                                    )}
                                />

                                <Route
                                    path="/pharmacyList"
                                    render={(props) => (
                                        <PharmacyList
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            cities={this.state.cities}
                                            branches={this.state.branches}
                                        />
                                    )}
                                />
                                <Route
                                    path="/isilanlari"
                                    render={(props) => (
                                        <JobPostingList
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            triggerDownloadRequestTooltip={
                                                this.triggerDownloadRequestTooltip
                                            }
                                        />
                                    )}
                                />
                                <Route
                                    path="/#"
                                    render={(props) => (
                                        <DetailModal
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            triggerDownloadRequestTooltip={
                                                this.triggerDownloadRequestTooltip
                                            }
                                        />
                                    )}
                                />

                                <Route
                                    path="/regions"
                                    render={(props) => (
                                        <Region
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            cities={this.state.cities}
                                            branches={this.state.branches}
                                        />
                                    )}
                                />
                                <Route
                                    path="/anlasmalar"
                                    render={(props) => (
                                        <DealList
                                            currentUser={this.state.currentUser}
                                            {...props}
                                            authorities={this.state.authorities}
                                            handleLogout={this.handleLogout}
                                            cities={this.state.cities}
                                            branches={this.state.branches}
                                        />
                                    )}
                                />

                            </Switch>
                            <Switch>
                                {/* Diğer yollar */}
                                <Route path="/nobetciParams" component={NobetParams}/>
                                {/* Diğer yollar */}
                            </Switch>

                            <Switch>
                                {/* Diğer yollar */}
                                <Route path="/nobetTalep" component={NobetTalep}/>
                                {/* Diğer yollar */}
                            </Switch>

                            <Route
                                path="/wpKullanıcıListesi"
                                render={(props) => (
                                    <WpUserList
                                        currentUser={this.state.currentUser}
                                        {...props}
                                        authorities={this.state.authorities}
                                        handleLogout={this.handleLogout}
                                        triggerDownloadRequestTooltip={
                                            this.triggerDownloadRequestTooltip
                                        }
                                    />

                                )}

                            />
                        </div>
                        <Footer/>
                    </div>
                </div>
                <Modal
                    title="Oturumunuz Sonlandırılacaktır"
                    visible={this.state.visible}
                    okText="Sonlandır"
                    cancelText="Devam Et"
                    onOk={this.handleLogout}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                >
                    <p>
                        <h4>
                            {this.state.maxIdleTimeout} dakika süresince işlem yapmadınız.
                            Oturumunuz {this.state.countBackFrom} saniye sonra otomatik olarak
                            sonlandırılacaktır!
                        </h4>
                    </p>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Master);



// WEBPACK FOOTER //
// ./src/layout/Master.js